// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"9c2c2e3d","224":"b9515855","350":"beed84d5","933":"0ed21561"}[chunkId] + ".chunk.css";
};